import React, { useState } from 'react';
import { FaFirefox, FaChrome } from 'react-icons/fa';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
  Link,
} from '@chakra-ui/react';

const BrowserSupport = () => {
  const [showBanner, setShowBanner] = useState(true);

  if (!showBanner) {
    return null;
  }

  return (
    <Box
      w="100%"
      mb={8}
      mt={{ base: '64px', lg: '0px' }}
      sx={{
        '@supports (display: grid) ': {
          display: 'none',
          width: 0,
          height: 0,
          visibility: 'hidden',
          left: -10000,
          top: -10000,
        },
      }}
    >
      <Alert data-testid="alert" status="warning" padding={8}>
        <Box mr={8}>
          <AlertIcon boxSize="36px" />
        </Box>
        <Box flex="1">
          <AlertTitle>Your Browser is no longer supported.</AlertTitle>
          <AlertDescription display="block">
            Datapoints no longer supports your browser. Please upgrade your
            browser.
            <Box display="flex" mt={4}>
              <Box mr={8}>
                <Box>
                  <Link
                    href="https://www.mozilla.org/en-GB/firefox/new/"
                    target="_blank"
                  >
                    <FaFirefox size="50px" />
                    Download FireFox
                  </Link>
                </Box>
              </Box>
              <Box mr={2}>
                <Box>
                  <Link
                    href="https://support.google.com/chrome/answer/95346?co=GENIE.Platform%3DDesktop&hl=en"
                    target="_blank"
                  >
                    <FaChrome size="50px" />
                    Download Chrome
                  </Link>
                </Box>
              </Box>
            </Box>
          </AlertDescription>
        </Box>
        <CloseButton
          onClick={() => setShowBanner(false)}
          position="absolute"
          right="8px"
          top="8px"
        />
      </Alert>
    </Box>
  );
};

export default BrowserSupport;
